import React, {useEffect, useState} from 'react';
import { FormGroup, Input, Badge, Button } from 'reactstrap';
import { ReactSortable } from 'react-sortablejs';

const CustomSortable = (props) => {
  const [items, setItems] = useState([])

  useEffect(() => {
    if (props.value) {
      let propsItems = props.value.split("|")
      propsItems= propsItems.map((item, index) => item = {id: index, label: item })
      setItems(propsItems)
    } else setItems([{id: 0, label: ""}])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let value = [...items]
    value = value.map(item => item = item.label)
    props.onChange(value.join("|"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  const addItem = () => {
    let nextId = 0
    if (items.length > 0) {
      var orderedAnswers = items.slice().sort((a, b) => b.id - a.id)
      nextId = orderedAnswers[0].id + 1
    }
    setItems([...items, { id: nextId, label: "" }])
  }

  const updateItem = (itemId, event) => {
    var itemIndex = items.findIndex(item => item.id === itemId)
    const updatedItems = [...items]
    const updatedItem = { ...updatedItems[itemIndex] }
    updatedItem.label = event.target.value
    updatedItems[itemIndex] = updatedItem
    setItems(updatedItems);
  }

  const removeItem = answerId => {
    setItems(items.filter(item => item.id !== answerId))
  }

  return (
    <div>
      <ReactSortable
        list={items}
        setList={(newState) => setItems(newState)}
        className="answers"
        options={{
          handle: '.handle',
        }}
      >
        {items.map(item => {
          return (
            <FormGroup
              data-id={item.id}
              key={item.id}
              className="mb-1"
            >
              <Input
                type="text"
                value={item.label}
                placeholder={props.placeholder}
                autoFocus
                onChange={event => {
                  updateItem(item.id, event)
                }}
              />
              <div className="input-icons">
                <Badge className="handle" color="empty" pill>
                  <i className="simple-icon-cursor-move" />
                </Badge>
                <Badge
                  color="empty"
                  pill
                  onClick={() => removeItem(item.id)}
                >
                  <i className="simple-icon-close" />
                </Badge>
              </div>
            </FormGroup>
          )
        })}
      </ReactSortable>

      <div className="text-center">
        <Button
          outline
          size="sm"
          color="primary"
          className="mt-3"
          onClick={() => addItem()}
        >
          <i className="simple-icon-plus btn-group-icon" /> {props.L[props.nameButton]?? "Add option"}
        </Button>
      </div>
    </div>
  )
}

export default CustomSortable

